export function CurrencyFormatter2(total: number) {
  return total.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
